import { AbstractControl, ValidatorFn } from '@angular/forms';

export const verificationCodeValidator: ValidatorFn = (control: AbstractControl) => {
  const value = control.value ? String(control.value).replaceAll('_', '') : '';
  return value.length !== 6 ? { codeLength: true } : null;
};
